export default __webpack_public_path__ + "static/media/black-delete-measure-icon.4444d772.svg";